"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _AccessibeLink = _interopRequireDefault(require("angieslist-app-platform/lib/browser/footer/AccessibeLink"));

require("./FooterCopyright.scss");

var _angieslistStyles = require("angieslist-styles");

var _li;

function renderLogoImageForFooter(spId, logo, homePageUrl) {
  var rootUrl = '/';
  return /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: homePageUrl || rootUrl,
    className: "pull-left",
    style: {
      marginRight: _angieslistStyles.stylesTypography.padding.small
    },
    id: "header--logo"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "logo",
    src: logo
  })));
}

var FooterCopyright = function FooterCopyright(_ref) {
  var links = _ref.links,
      logo = _ref.logo,
      spId = _ref.spId,
      isAngiLeads = _ref.isAngiLeads;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 8,
    lg: 9
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "copyright-desktop"
  }, logo ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "copy-right-logo"
  }, spId && isAngiLeads ? renderLogoImageForFooter(spId, logo, _urlCatalog["default"].office.leads.homePage(spId)) : spId && !isAngiLeads ? renderLogoImageForFooter(spId, logo, _urlCatalog["default"].office.ads.home(spId)) : renderLogoImageForFooter(spId, logo, _urlCatalog["default"].office.home())) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-padding-copyright"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "links-unstyled-spacing mobile-center"
  }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", null, "\xA9 Copyright 1995-", new Date().getFullYear(), ",", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: _urlCatalog["default"].global.angiesListHome(),
    title: "Angi Homepage"
  }, "Angi"), ". All Rights Reserved.")))))), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 12,
    lg: 9
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-padding-links"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "links-unstyled-spacing"
  }, Object.keys(links).map(function (link, i) {
    return /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
      key: "".concat(i + 1)
    }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
      key: "".concat(i + 1)
    }, /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
      target: "_blank",
      rel: "noopener noreferrer"
    }, links[link], {
      id: "footer--copyright-link-".concat(i + 1),
      className: "copy-right-link"
    }), link))));
  }), _li || (_li = /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "copy-right-link"
  }, /*#__PURE__*/_react["default"].createElement(_AccessibeLink["default"], {
    description: "Accessibility Tools"
  }))))))));
};

var _default = FooterCopyright;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/footer/FooterCopyright.js
// module id = 3646
// module chunks = 25